import '../common/bn-tabs';
import './parts/work-order-locations';
import './parts/work-orders-by-state';
import { css, html, LitEntity, SirenActionMixin, renderIf } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import { StoreMixin } from '../utility/store-mixin';
import { sharedStyles } from '../styles/shared-styles';

class WorkOrderLocationsIndex extends StoreMixin(IndexMixin(SirenActionMixin(LitEntity))) {
  static get properties() {
    return {
      readyHref: { type: String, attribute: false },
      delegatedHref: { type: String, attribute: false },
      assignedHref: { type: String, attribute: false },
      orgType: { type: String, attribute: false },
      workOrdersHref: { type: String, attribute: false },
      workOrderLocationsHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .header {
        margin: 0 .5rem .5rem;
      }
    `];
  }

  render() {
    let view = this.currentView;
    return html`
      <lit-entity href="${this.workOrderLocationsHref}" @update="${this._onUpdateWorkOrderLocations}"></lit-entity>
      <div class="header">
        <h1>Work Orders</h1>
      </div>
      <bn-tabs>
        ${renderIf(this.orgType === 'service-account', () => html`
          <bn-tab href="/work-order-locations/ready" ?active="${view === 'ready'}">Ready</bn-tab>
        `)}
        <bn-tab href="/work-order-locations/delegated" ?active="${view === 'delegated'}">Delegated</bn-tab>
        <bn-tab href="/work-order-locations/assigned" ?active="${view === 'assigned'}">Assigned</bn-tab>
        <bn-tab href="/work-order-locations/completed" ?active="${view === 'completed'}">Completed</bn-tab>
        ${renderIf(this.orgType === 'service-account', () => html`
          <bn-tab href="/work-order-locations/rejected" ?active="${view === 'rejected'}">Rejected</bn-tab>
          <bn-tab href="/work-order-locations/accepted" ?active="${view === 'accepted'}">Accepted</bn-tab>
          <bn-tab href="/work-order-locations/hold" ?active="${view === 'hold'}">On Hold</bn-tab>
        `)}
        </bn-tabs>
      ${super.render()}
    `;
  }

  getViews() {
    return [
      {
        default: this.orgType === 'service-account',
        name: 'ready',
        render: () => html`<work-order-locations .href="${this.readyHref}"></work-order-locations>`,
      },
      {
        default: this.orgType === 'service-partner',
        name: 'delegated',
        render: () => html`<work-order-locations .href="${this.delegatedHref}"></work-order-locations>`,
      },
      {
        name: 'assigned',
        render: () => html`<work-order-locations .href="${this.assignedHref}"></work-order-locations>`,
      },
      {
        name: 'hold',
        render: () => html`<work-orders-by-state .href="${this.workOrdersHref}" historical full-path state="hold"></work-orders-by-state>`,
      },
      {
        name: 'completed',
        render: () => html`<work-orders-by-state .href="${this.workOrdersHref}" historical full-path state="completed"></work-orders-by-state>`,
      },
      {
        name: 'rejected',
        render: () => html`<work-orders-by-state .href="${this.workOrdersHref}" historical full-path state="rejected"></work-orders-by-state>`,
      },
      {
        name: 'accepted',
        render: () => html`<work-orders-by-state .href="${this.workOrdersHref}" historical full-path state="accepted"></work-orders-by-state>`,
      },
    ];
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.workOrderLocationsHref = this.getHref('https://api.binsentry.com/rel/work-order-locations');
    this.workOrdersHref = this.getHref('https://api.binsentry.com/rel/work-orders');
  }

  _onUpdateWorkOrderLocations(e) {
    const { entity } = e.detail;
    const action = entity && entity.getAction('filter-work-order-locations');
    if (!action) {
      return;
    }
    const { url } = this.parseAction(action);
    url.searchParams.set('state', 'ready');
    this.readyHref = url.href;
    url.searchParams.set('state', 'delegated');
    this.delegatedHref = url.href;
    url.searchParams.set('state', 'assigned');
    this.assignedHref = url.href;
  }

  _stateChanged({ organizationType }) {
    this.orgType = organizationType;
  }
}

customElements.define('work-order-locations-index', WorkOrderLocationsIndex);
